<script>
  import {getContext} from 'svelte';
  import {LINKS} from '@/const/link';
  import {envUtil} from '@/helper/env';
  import {bridge} from '@/helper/bridge';
  import Button from '@/widgets/Button.svelte';
  import {myEntryInfo$, gameStatus$} from '../stream';
  import lang from '../TradeCompetitionPage.lang';

  const LG = getContext('LG');

  function tradeNow() {
    if (envUtil.isApp) {
      bridge.postMessage('toContractTrade');
      return;
    }
    window.location.assign(`${LINKS.PHEMEX_CONTRACT_TRADE}/BTCUSD`);
  }

  function gotoContractAccount() {
    if (envUtil.isApp) {
      bridge.postMessage('toViewBonus');
      return;
    }
    window.location.assign('/assets/overview?tab=Contract');
  }
</script>

<style>
  .entry-information {
    display: flex;
    padding: 40px 40px 0 40px;
    box-sizing: border-box;
    width: 100%;
    background: #0d131b;
  }
  .data-column {
    flex: 2;
  }
  .data-column.long {
    flex: 3;
  }
  .data-label {
    padding-bottom: 16px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
  }
  .data-value {
    padding-bottom: 40px;
    font-size: 36px;
    font-weight: bold;
    color: #fff;
  }
  .small-data-value {
    display: inline-block;
    padding-bottom: 20px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
  }
  .buttons {
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
  }

  @media screen and (min-width: 640px) {
    .data-column {
      display: block;
    }
    .data-row {
      display: none;
    }
    .h5 {
      display: none;
    }
  }

  @media screen and (max-width: 640px) {
    .data-column {
      display: none;
    }
    .data-row {
      display: flex;
      justify-content: space-between;
    }
    .entry-information {
      flex-direction: column;
      padding: 0;
      background: transparent;
    }
    .h5 {
      display: block;
    }
  }
</style>

{#if $myEntryInfo$.isJoinedCompetition}
  <div class="entry-information">
    <div class="data-column">
      <div class="data-label">{LG(lang.MyTradingVolume)}</div>
      <div class="data-value">
        {$gameStatus$.isBeforeCompetition ? '--' : $myEntryInfo$.tradingVolume}
      </div>
    </div>
    <div class="data-column">
      <div class="data-label">{LG(lang.TradingVolumeRanking)}</div>
      <div class="data-value">
        {$gameStatus$.isBeforeCompetition ? '--' : $myEntryInfo$.tradingRanking}
      </div>
    </div>
    <div class="data-column long">
      <div class="buttons">
        <Button type="primary" class="wsn" on:click={tradeNow}>{LG(lang.SpotTrade)}</Button>
        <Button type="primary" class="wsn" on:click={gotoContractAccount}>{LG(lang.ContractTrade)}</Button>
      </div>
    </div>
    <div class="data-row">
      <div class="data-label">{LG(lang.MyTradingVolume)}</div>
      <div class="data-label tr">{LG(lang.TradingVolumeRanking)}</div>
    </div>
    <div class="data-row">
      <div class="small-data-value">
        {$gameStatus$.isBeforeCompetition ? '--' : $myEntryInfo$.tradingVolume}
      </div>
      <div class="small-data-value">
        {$gameStatus$.isBeforeCompetition ? '--' : $myEntryInfo$.tradingRanking}
      </div>
    </div>
    <div class="h5 mb20 tc">
      <Button minWidth="270px" type="primary" on:click={tradeNow}>{LG(lang.SpotTrade)}</Button>
    </div>
    <div class="h5 tc">
      <Button minWidth="270px" type="primary" on:click={gotoContractAccount}>{LG(lang.ContractTrade)}</Button>
    </div>
  </div>
{/if}
